/* eslint import/prefer-default-export: off */
import Breakpoints from '../../themes/Breakpoints/breakpoints';

/**
 * Gets the viewport based on the Breakpoint values
 * @param {String} width width of the current viewport
 */
export const getViewport = (width) => {
  if (width >= Breakpoints.desktopWide) return 'desktopWide';
  if (width >= Breakpoints.desktopLarge) return 'desktopLarge';
  if (width >= Breakpoints.desktop) return 'desktop';
  if (width >= Breakpoints.tablet) return 'tablet';

  return 'mobile';
};
